/**
 * Created by fers on 19/03/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceCompanySearchEdit from './DataSourceCompanySearchEdit.react';

import DataSourceDecorationEdit from './DataSourceDecorationEdit.react';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import types from '../../../common/model-api/types';
import urlMapping from '../../app/URLMapping';
import {Link} from 'react-router';
import commonConfig from '../../../common/config';

export const handlerName = "company-search";
export const config = DataSourceCompanySearchEdit;

class DataSourceCompanySearchAdd extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        dataSource: PropTypes.object.isRequired,
        goBack: PropTypes.func,
        intl: PropTypes.object,
    };

    render() {
        let dataSource = this.props.dataSource;

        try {
            return (
                <DataSourceDecorationEdit
                    dataSource={dataSource}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        <p><FormattedMessage defaultMessage="Company searching can be configured in organisation settings."
                                          id="DataSourceCompanySearchEdit.dataSource.description"/></p>
                        <Link className="btn btn-primary" target="_blank" to={commonConfig.PUBLIC_APP_URL + urlMapping.getUrl(types['organisations'], 'company-search', dataSource.screen.organisation)}><FormattedMessage defaultMessage="Configure company search"
                                                                                                                                                                                            id="DataSourceCompanySearchEdit.dataSource.link"/></Link>
                    </div>
                </DataSourceDecorationEdit>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}

export default Relay.createContainer(injectIntl(DataSourceCompanySearchAdd), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    name,
                    description,
                    idx,
                    relativeTo {
                        id,
                        name
                    },
                    channelDefs {
                        id,
                        icon,
                        name,
                    },
                    entityDefs {
                        id,
                        name,
                    },
                    screen {
                        id,
                        organisation {
                            id,
                            realId,
                            name
                        }
                    }
                }`;
        }
    }
});
